import nodeAPI from '../../../service/ApiServiceNode';

const unwrap = (response) => {
    if (!response || response.data === undefined) {
        throw new Error('Notification preferences API returned an empty response');
    }
    const body = response.data;
    if (body && typeof body === 'object' && 'data' in body) {
        return body.data;
    }
    return body;
};

export const getPreferences = () =>
    nodeAPI.get('/notification/preferences').then(unwrap);

export const saveCategoryPreference = (category, body) =>
    nodeAPI
        .put(`/notification/preferences/category/${encodeURIComponent(category)}`, body)
        .then(unwrap);

export const saveEventOverride = (eventKey, body) =>
    nodeAPI
        .put(`/notification/preferences/event/${encodeURIComponent(eventKey)}`, body)
        .then(unwrap);

export const resetEventOverride = (eventKey) =>
    nodeAPI
        .delete(`/notification/preferences/event/${encodeURIComponent(eventKey)}`)
        .then(unwrap);

export const sendTestNotification = (channel) =>
    nodeAPI.post('/notification/preferences/test', { channel }).then(unwrap);
